import { DeviceBrandOutputWithStatusAndDeviceModel } from './device-brand-output-with-status-and-device-model.model';


export class DeviceBrandSelectByIdOutput implements IDeviceBrandSelectByIdOutput {
    status!: number;
    message!: string;
    data!: DeviceBrandOutputWithStatusAndDeviceModel;

    constructor(data?: IDeviceBrandSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DeviceBrandOutputWithStatusAndDeviceModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceBrandSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBrandSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeviceBrandSelectByIdOutput {
    status: number;
    message: string;
    data: DeviceBrandOutputWithStatusAndDeviceModel;
}

